// extracted by mini-css-extract-plugin
export var defaultWrapper = "_fo-3";
export var downloadButton = "_fo-4";
export var fileContainer = "_fo-9 _fo-7";
export var fileContainerBase = "_fo-7";
export var fileContainerFixedHeight = "_fo-8 _fo-7";
export var fileInfo = "_fo-5";
export var fileInfoWidthRestricted = "_fo-6";
export var fileType = "_fo-1";
export var fileTypeName = "_fo-2";
export var image = "_fo-0";
export var link = "_fo-b";
export var overflowEllipsis = "_fo-a";